"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "_base",
  group: "_hidden",
  init: "1",
  // 1 per 8 hours
  prod: { _lootGrindToken: "" + 1 / (60 * 60 * 8) }
}, {
  name: "_lootGrindToken",
  group: "_hidden",
  init: "4"
}, {
  name: "nest",
  prod: { queen: "3" },
  cost: { queen: "1e3", larva: "1" },
  group: "meat"
}, {
  name: "queen",
  prod: { drone: "2" },
  cost: { drone: "1e2", larva: "1" },
  group: "meat"
}, {
  name: "drone",
  prod: { meat: "1" },
  cost: { meat: "1e1", larva: "1" },
  group: "meat"
}, {
  name: "meat",
  group: "meat",
  init: "30"
}, {
  name: "larva",
  group: "larva",
  init: "100"
}, {
  name: "hatchery",
  prod: { larva: "1" },
  group: "larva"
}, {
  name: "swarmling-queen",
  group: "combat",
  cost: { meat: "1000" },
  init: "0"
}, {
  name: "overlord-den",
  group: "combat",
  cost: { meat: "1000000" },
  init: "0"
}, {
  name: "tower",
  group: "combat",
  cost: { meat: "1000000" },
  init: "0"
}];
// Why .js, not .json? Because .json files can't have comments, require quoted
// keys, have issues importing in some contexts, and can't be type checked.
//
// order matters here - this is the order of the list on /p/.../units
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/unit-types/json.js
// module id = 778
// module chunks = 0